module.exports = __webpack_public_path__ + "static/media/29BDOS12.328ed552.jpg";